export class StockSearchPillCollectionBase {

    constructor() {

        this.skuGroup = {
            enabled: true,
            history: []
        };

        this.skuName = {
            enabled: true,
            history: []
        };

        this.skuNumber = {
            enabled: true,
            history: []
        };

        this.skuDescription = {
            enabled: true,
            history: []
        };

        this.warehouse = {
            enabled: true,
        };

        this.descHeadOne = {
            label: '',
            enabled: true,
            history: []
        };

        this.descHeadTwo = {
            label: '',
            enabled: true,
            history: []
        };

        this.descHeadThree = {
            label: '',
            enabled: true,
            history: []
        };

        this.descHeadFour = {
            label: '',
            enabled: true,
            history: []
        };

        this.descHeadFive = {
            label: '',
            enabled: true,
            history: []
        };

        this.descHeadSix = {
            label: '',
            enabled: true,
            history: []
        }

    }
}
